import {Column} from 'react-table'
import {SubscriptionPlan} from '../../core/_models'
import {IndexCell} from '../../../../../../services/table/columns/IndexCell'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {AssignPlanCell} from './AssignPlanCell'
import {FullDateAndTimeCell} from '../../../../../../services/table/columns/FullDateAndTimeCell'
import {TableCustomHeader} from '../../../../../../services/table/columns/TableCustomHeader'
import {NameCell} from '../../../../../../services/table/columns/NameCell'

const subscriptionPlansColumns: ReadonlyArray<Column<SubscriptionPlan>> = [
  {
    Header: (props) => (
      <TableCustomHeader tableProps={props} title='#' useQueryRequest={useQueryRequest} />
    ),
    id: 'index',
    accessor: 'id',
    disableSortBy: true,
    Cell: ({...props}) => (
      <IndexCell rowIndex={props.row.index} useQueryRequest={useQueryRequest} />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Company'
        className='min-w-100px'
        useQueryRequest={useQueryRequest}
      />
    ),
    accessor: 'name',
    disableSortBy: false,
    Cell: ({row}) => (
      <NameCell
        name={row?.original?.name ? row?.original?.name : '-'}
        isTextTruncated={true}
        truncatedClassName='max-w-130px'
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Date & Time'
        className='min-w-140px'
        useQueryRequest={useQueryRequest}
      />
    ),
    id: 'created_at',
    accessor: 'created_at',
    disableSortBy: false,
    Cell: ({...props}) => <FullDateAndTimeCell row={props.row} />,
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Team Size'
        className='min-w-68px'
        useQueryRequest={useQueryRequest}
      />
    ),
    accessor: 'team_size',
    disableSortBy: false,
    Cell: ({row}) => {
      return (
        <>
          {row?.original?.team_size?.size && (
            <div>{row?.original?.team_size?.size ? row?.original?.team_size?.size : '-'}</div>
          )}
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Email'
        className='min-w-65px'
        useQueryRequest={useQueryRequest}
      />
    ),
    id: 'email',
    accessor: 'email',
    disableSortBy: false,
    Cell: ({row}) => {
      return (
        <>
          <div className='d-flex justify-content-center flex-column'>
            {row?.original?.email ? (
              <div className='manage-title-truncate emailFieldEnter' title={row?.original?.email}>
                {row?.original?.email}
              </div>
            ) : (
              <div>-</div>
            )}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Mobile'
        className='min-w-130px'
        useQueryRequest={useQueryRequest}
      />
    ),
    id: 'phone',
    accessor: 'phone',
    disableSortBy: false,
    Cell: ({row}) => {
      return (
        <>
          <div className='d-flex align-item-center'>
            {row?.original?.phone ? (
              <div>
                +{row?.original?.country_code} {row?.original?.phone}
              </div>
            ) : (
              <div>-</div>
            )}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='City'
        className='min-w-90px'
        useQueryRequest={useQueryRequest}
      />
    ),
    accessor: 'city',
    id: 'city',
    disableSortBy: false,
    Cell: ({row}) => {
      return (
        <>
          <div className='d-flex align-items-center'>
            {row?.original?.city ? <div>{row?.original?.city}</div> : <div>-</div>}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Country'
        className='min-w-90px'
        useQueryRequest={useQueryRequest}
      />
    ),
    accessor: 'country',
    id: 'country',
    disableSortBy: false,
    Cell: ({row}) => {
      return (
        <>
          <div className='d-flex justify-content-center flex-column'>
            {row?.original?.country ? <div>{row?.original?.country}</div> : <div>-</div>}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Payment Status'
        className='min-w-100px'
        useQueryRequest={useQueryRequest}
      />
    ),
    id: 'paymentStatus',
    disableSortBy: true,
    Cell: ({row}: {row: any}) => {
      return (
        <>
          <div className='d-flex align-items-center'>
            {row?.original?.plans ? (
              <>
                {row?.original?.plans?.[0]?.subscription.type !== 'enterprise' ? (
                  <div>{row?.original?.plans?.[0]?.payment_status}</div>
                ) : (
                  <div>-</div>
                )}
              </>
            ) : row?.original?.request_type === 'enterprise_upgrade' ? (
              <div>{row?.original?.upgrade_payment_status || '-'}</div>
            ) : (
              <div>-</div>
            )}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <TableCustomHeader
        tableProps={props}
        title='Plan'
        className='min-w-120px text-end'
        useQueryRequest={useQueryRequest}
        isActionColumn={true}
      />
    ),
    accessor: 'assign_plan',
    disableSortBy: true,
    Cell: ({row}: {row: any}) => <AssignPlanCell row={row.original} />,
  },
]

export {subscriptionPlansColumns}
